import { DigioPolicyOParamType } from './../../types/T&CnPolicy';
import { DigioPolicyResponseType, TnCPolicyOParamType, TnCPolicyResponseType } from '../../types/T&CnPolicy';
import { axiosInstance } from './index';

export const TnCPolicyService = {
    async getPublicPolicyDocument(params: TnCPolicyOParamType) {
        const { data } = await axiosInstance.post(`User/GetPublicPolicyDocument`, params);
        return data as TnCPolicyResponseType;
    },

    async getDigioExternalTokenForPolicy(params: DigioPolicyOParamType) {
        const { data } = await axiosInstance.get(`User/GetDigioExternalTokenForPolicy`, { params });
        return data as DigioPolicyResponseType;
    },

    async uploadPolicyDocument(params: DigioPolicyOParamType) {
        await axiosInstance.post(`User/UploadPolicyDocuments`, params);
    },

    async uploadHRMSPolicyDocument(params: DigioPolicyOParamType) {
         await axiosInstance.post(`HRMSUser/UploadHRMSPolicyDocuments`, params);
    },
};
